import React, { useState } from 'react';
import { CheckCircle2, Lock, Zap, CreditCard, Star } from 'lucide-react';
type PlanId = 'docente' | 'completo';
interface Plan {
  id: PlanId;
  name: string;
  desc: string;
  oldPrice: string;
  price: string;
  url: string;
  save?: string;
  recommended?: boolean;
}
const plans: Plan[] = [{
  id: 'docente',
  name: 'PACK DOCENTE 2026',
  desc: '6 Tomos + 6 Bonos Imprimibles',
  oldPrice: '$34.990',
  price: '$19.990',
  url: 'https://www.nexorecursos.com/cart/52576286998804:1'
}, {
  id: 'completo',
  name: 'PACK COMPLETO',
  desc: '6 Tomos + 6 Bonos + Master Kit de Evaluación™',
  oldPrice: '$43.990',
  price: '$27.990',
  url: 'https://www.nexorecursos.com/cart/52576293191956:1',
  save: 'AHORRÁS $16.000',
  recommended: true
}];
export const OfferSelector = () => {
  const [selected, setSelected] = useState<PlanId>('completo');
  const selectedPlan = plans.find(p => p.id === selected)!;
  const handleBuy = () => {
    window.location.href = selectedPlan.url;
  };
  return <div className="max-w-3xl mx-auto" data-id="element-181">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-182">
        {plans.map(plan => {
        const isSelected = selected === plan.id;
        return <button key={plan.id} type="button" onClick={() => setSelected(plan.id)} aria-pressed={isSelected} className={`relative text-left rounded-2xl p-5 transition-all duration-200 border-2 focus:outline-none focus:ring-2 focus:ring-brand-orange/50 ${isSelected ? 'border-brand-orange bg-white shadow-lg ring-1 ring-brand-orange/30' : 'border-gray-200 bg-white/70 hover:border-brand-orange/40'} ${plan.recommended ? 'sm:scale-[1.03]' : ''}`} data-id="element-183">
              {plan.recommended && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-gold text-brand-green font-bold px-3 py-0.5 rounded-full text-xs shadow-md flex items-center gap-1 w-max" data-id="element-184">
                  <Star size={12} className="fill-brand-green" data-id="element-185" /> MÁS ELEGIDO
                </div>}

              {/* Radio + title */}
              <div className="flex items-start gap-3 mb-2 mt-1" data-id="element-186">
                <span className={`mt-0.5 flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-brand-orange bg-brand-orange' : 'border-gray-300'}`} data-id="element-187">
                  {isSelected && <span className="w-2 h-2 rounded-full bg-white" data-id="element-188" />}
                </span>
                <div data-id="element-189">
                  <h3 className="font-heading font-bold text-gray-900 leading-tight" data-id="element-190">
                    {plan.name}
                  </h3>
                  <p className="text-gray-500 text-xs mt-0.5" data-id="element-191">{plan.desc}</p>
                </div>
              </div>

              {plan.save && <div className="ml-8 inline-block bg-brand-green/10 text-brand-green text-[11px] font-bold px-2 py-0.5 rounded-full mb-1" data-id="element-192">
                  {plan.save}
                </div>}

              <div className="ml-8 flex items-baseline gap-2" data-id="element-193">
                <span className="text-3xl font-heading font-extrabold text-gray-900" data-id="element-194">
                  {plan.price}
                </span>
                <span className="text-gray-400 line-through text-sm" data-id="element-195">
                  {plan.oldPrice}
                </span>
              </div>
            </button>;
      })}
      </div>

      {/* Shared buy button */}
      <button onClick={handleBuy} className="w-full mt-6 bg-brand-orange hover:bg-brand-orange/90 text-white font-bold text-lg px-8 py-4 rounded-xl shadow-soft transform transition hover:-translate-y-0.5 flex items-center justify-center gap-2" data-id="element-196">
        {selected === 'completo' ? '✅ SÍ, QUIERO EL PACK COMPLETO' : '💥 QUIERO MI PACK DOCENTE AHORA'}
        <span className="font-extrabold" data-id="element-197">— {selectedPlan.price}</span>
      </button>

      {/* Trust Row */}
      <div className="mt-5 flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm text-gray-600 font-medium" data-id="element-198">
        <span className="flex items-center gap-1.5" data-id="element-199">
          <Lock size={16} className="text-gray-400" data-id="element-200" /> Pago seguro
        </span>
        <span className="flex items-center gap-1.5" data-id="element-201">
          <Zap size={16} className="text-brand-amber" data-id="element-202" /> Acceso en 5 min
        </span>
        <span className="flex items-center gap-1.5" data-id="element-203">
          <CheckCircle2 size={16} className="text-green-600" data-id="element-204" /> Garantía 7 días
        </span>
        <span className="flex items-center gap-1.5" data-id="element-205">
          <CreditCard size={16} className="text-blue-500" data-id="element-206" /> Mercado Pago
        </span>
      </div>
    </div>;
};